import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export function UpgradePrompt({ feature, requiredPlan = 'platinum' }) {
  const navigate = useNavigate();
  const planLabel = requiredPlan === 'diamond' ? 'Diamond' : 'Platinum';

  return (
    <div className="p-4 rounded-xl border-2 border-amber-300 bg-amber-50 flex items-center gap-3">
      <Lock size={20} className="text-amber-600 flex-shrink-0" />
      <div className="flex-1">
        <p className="text-base font-semibold text-amber-900">
          Plano {planLabel} necessário
        </p>
        <p className="text-sm text-amber-700">
          Faça upgrade para {feature}.
        </p>
      </div>
      <Button
        onClick={() => navigate('/minha-conta')}
        className="bg-[#1B2A4A] hover:bg-[#2a3d66] text-white text-sm px-4 py-2 rounded-lg flex items-center gap-1 flex-shrink-0"
      >
        Ver Planos
        <ArrowRight size={16} />
      </Button>
    </div>
  );
}

export function LimitBadge({ current, max }) {
  const atLimit = current >= max;
  const nearLimit = current >= max - 1;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-semibold ${
        atLimit
          ? 'bg-red-100 text-red-800'
          : nearLimit
          ? 'bg-amber-100 text-amber-800'
          : 'bg-slate-100 text-slate-600'
      }`}
    >
      {current}/{max}
    </span>
  );
}
